module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/th/3-f2c15f5dc1d22958b872b2ac87331885.jpg";